module.exports = __webpack_public_path__ + "media/images/icon-reveal-ed28fb6393fff85d22ccb8eacbf2183a.svg";